import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaServiceService {

  private siteKey = environment.siteKey;

  constructor(private http: HttpClient) { }

  executeAction(action: string): Observable<string> {
    return new Observable<string>((observer) => {
      if (typeof window != 'undefined') {
        window.grecaptcha.enterprise.ready(() => {
          Promise.resolve(
            window.grecaptcha.enterprise.execute(this.siteKey, { action })
          )
            .then((token: string) => {
              observer.next(token);
              observer.complete();
            })
            .catch((error: any) => {
              console.error('Error al ejecutar reCAPTCHA:', error);
              observer.error(error);
            });
        });
      }
    });
  }

  
}
